"use client"
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import { SidebarTrigger, useSidebar } from "@/components/ui/sidebar"
import { Separator } from "@/components/ui/separator"
import { Menu } from "lucide-react"
import { Button } from "@/components/ui/button"
import { useIsMobile } from "@/hooks/use-mobile"
import { ModeToggle } from "@/components/shared/ModeToggle.tsx"
import { FeedbackDialog } from "@/components/shared/FeedbackDialog"
import { NavigationBreadcrumb } from "@/components/shared/NavigationBreadcrumb"
import { UserBlock } from "@/components/shared/UserBlock"
import MapLogoVertical from "@/assets/MAP_logo_vertical.svg?react"
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip.tsx"



export function Header() {
  const isMobile = useIsMobile()
  const { toggleSidebar } = useSidebar()
  const { state } = useSidebar()
  const isCollapsed = state === "collapsed"

  return (
    <header className="flex max-h-[48px] h-12 shrink-0 items-center gap-2 border-b pl-2 pr-4">
      {isMobile ? (
        <>
          <MapLogoVertical className="!w-[28px] !h-[28px] shrink-0" aria-label="MAP" />
          <Button variant="ghost" size="icon-sm" onClick={toggleSidebar} className="cursor-pointer">
            <Menu className="size-5" />
            <span className="sr-only">Toggle Sidebar</span>
          </Button>
        </>
      ) : (
        <>
          <Tooltip>
            <TooltipTrigger asChild>
              <SidebarTrigger />
            </TooltipTrigger>
            <TooltipContent>
              <p>{isCollapsed ? "Expand Menu" : "Collapse Menu"}</p>
            </TooltipContent>
          </Tooltip>
          <Separator orientation="vertical" className="mr-1 h-12" />
          <NavigationBreadcrumb />
        </>
      )}

      <div className="flex-1" />
      <div className="flex items-center gap-1">
        <FeedbackDialog />
        <ModeToggle />
        <UserBlock />
      </div>
    </header>
  )
}
